// Theme tokens exposed in JS form for code that needs the literal
// values (e.g. inline-style fallbacks or chart libraries that don't
// read CSS variables). Mirrors `src/styles/globals.css` exactly —
// edit both when changing the palette.

export const STRAWBERRY = {
  50: "hsl(355 100% 98%)",
  100: "hsl(355 90% 95%)",
  200: "hsl(353 85% 90%)",
  300: "hsl(351 80% 82%)",
  400: "hsl(347 75% 70%)",
  500: "hsl(343 70% 65%)",
  600: "hsl(339 75% 58%)",
  700: "hsl(335 70% 48%)",
  800: "hsl(332 65% 40%)",
  900: "hsl(330 60% 35%)",
} as const;

export const CLOUD = {
  50: "hsl(220 25% 99%)",
  100: "hsl(220 25% 96%)",
  200: "hsl(220 22% 91%)",
  300: "hsl(220 18% 84%)",
  400: "hsl(220 14% 65%)",
  500: "hsl(220 14% 46%)",
  600: "hsl(220 22% 22%)",
  700: "hsl(222 30% 14%)",
  800: "hsl(222 35% 8%)",
  900: "hsl(224 40% 6%)",
} as const;

export const GRAPE = {
  50: "hsl(282 65% 98%)",
  100: "hsl(280 60% 95%)",
  200: "hsl(278 55% 90%)",
  300: "hsl(275 50% 82%)",
  400: "hsl(270 45% 70%)",
  500: "hsl(265 45% 58%)",
  600: "hsl(263 50% 48%)",
  700: "hsl(262 55% 38%)",
  800: "hsl(262 60% 28%)",
  900: "hsl(262 65% 18%)",
} as const;

/** Predefined accent colors for the per-user accent picker (Req 18.3). */
export const ACCENT_COLORS = [
  { id: "strawberry", label: "Pink", hsl: "343 70% 65%" },
  { id: "rose", label: "Rose", hsl: "351 80% 70%" },
  { id: "peach", label: "Peach", hsl: "20 90% 70%" },
  { id: "lavender", label: "Lavender", hsl: "260 60% 75%" },
  { id: "grape", label: "Grape", hsl: "270 55% 60%" },
  { id: "sky", label: "Sky", hsl: "200 80% 65%" },
  { id: "mint", label: "Mint", hsl: "160 60% 55%" },
  { id: "lemon", label: "Lemon", hsl: "45 90% 65%" },
  { id: "graphite", label: "Graphite", hsl: "215 28% 30%" },
] as const;

export type AccentId = (typeof ACCENT_COLORS)[number]["id"];
